class dataObj {
  constructor() {
    this.data = {};
  }
  // 设置
  set(key, value) {
    this.data[key] = value;
  }
  get(key) {
    // 默认值设置
    let value = this.data && this.data[key] ? this.data[key] : null;
    return value;
  }

  remove(key) {
    delete this.data[key];
  }
}

export default new dataObj();
